import { compact } from 'lodash-es';
import { composeValidators, requiredValidation, getRichTextValidator } from 'validators';
import { extractPureTextFromRichText } from 'seagull/components/RichTextEditor/RichTextEditor';
const CUSTOM_MESSAGE_MAX_LENGTH = 4000;
export const makeContactValidators = (param)=>{
    let { validators, texts } = param;
    return {
        firstName: validators.getNameValidator(texts.firstName(), texts.firstNameRequired()),
        lastName: validators.getNameValidator(texts.lastName(), texts.lastNameRequired()),
        email: validators.getEmailValidator(undefined, texts.emailRequired()),
        companyName: validators.getCompanyNameValidator(undefined, texts.companyNameRequired())
    };
};
export const makeAgreementRecipientValidators = (param)=>{
    let { validators, texts } = param;
    return {
        firstName: validators.getNameValidator(texts.firstName()),
        lastName: validators.getNameValidator(texts.lastName()),
        email: validators.getEmailValidator()
    };
};
export const makeAgreementValidators = (param)=>{
    let { validators, texts } = param;
    const getOptionalAgreementNameValidator = (allowEmpty)=>validators.getTitleValidator(texts.agreementName(), allowEmpty ? false : texts.agreementNameRequired());
    const getOptionalAgreementNameValidation = (allowEmpty)=>({
            validate: {
                title: getOptionalAgreementNameValidator(allowEmpty)
            },
            dataAttr: {
                'data-validation': 'title'
            }
        });
    const getCustomMessageValidation = (param)=>{
        let { label, required, maxLength = CUSTOM_MESSAGE_MAX_LENGTH } = param;
        return composeValidators(compact([
            required && requiredValidation(texts.required()),
            validators.maxLengthValidation(maxLength, label),
            validators.noHtmlPatternValidation(label)
        ]));
    };
    const introMessageRules = getCustomMessageValidation({
        label: texts.introductoryMessage(),
        required: true
    });
    const persistableIntroMessageRules = getCustomMessageValidation({
        label: texts.introductoryMessage(),
        required: false
    });
    return {
        agreementNameValidator: getOptionalAgreementNameValidator(false),
        agreementNameValidation: getOptionalAgreementNameValidation(false),
        getOptionalAgreementNameValidator,
        getOptionalAgreementNameValidation,
        templateNameValidator: validators.getTitleValidator(texts.templateName(), texts.templateNameRequired()),
        templateNameValidation: validators.titleValidation(texts.templateName(), {
            required: texts.templateNameRequired()
        }),
        getCustomMessageValidation,
        introMessageRules,
        persistableIntroMessageRules,
        validateIntroMessage: (value)=>validateViaRHF(introMessageRules, value),
        validatePersistableIntroMessage: (value)=>validateViaRHF(persistableIntroMessageRules, value)
    };
};
export const MAX_LEGAL_TERMS_NAME_LENGTH = 80;
export const MAX_LEGAL_TERMS_CONTENT_LENGTH = 100000;
export const validateLegalTermsName = (name)=>{
    if (name.trim() === '') return {
        valid: false,
        error: 'empty'
    };
    if (name.length > MAX_LEGAL_TERMS_NAME_LENGTH) return {
        valid: false,
        error: 'tooLong'
    };
    return {
        valid: true
    };
};
export const validateLegalTermsContent = (contentDelta)=>{
    if (contentDelta == null) return {
        valid: true
    };
    if (extractPureTextFromRichText(contentDelta).length > MAX_LEGAL_TERMS_CONTENT_LENGTH) {
        return {
            valid: false,
            error: 'tooLong'
        };
    }
    return {
        valid: true
    };
};
const quillContentRichTextValidator = getRichTextValidator();
export const quillContentHasHtmlTags = (content)=>content != null && quillContentRichTextValidator(JSON.stringify(content.value)) !== true;
export const validateQuillLegalTermsContent = (contentDelta)=>{
    const lengthResult = validateLegalTermsContent(contentDelta);
    if (!lengthResult.valid) return lengthResult;
    if (quillContentHasHtmlTags(contentDelta)) {
        return {
            valid: false,
            error: 'htmlTags'
        };
    }
    return {
        valid: true
    };
};
export const validateViaRHF = (rule, value)=>{
    const validators = rule.validate;
    if (!validators || typeof validators !== 'object') return undefined;
    for (const validator of Object.values(validators)){
        if (typeof validator === 'function') {
            const result = validator(value !== null && value !== void 0 ? value : '');
            if (result !== true && typeof result === 'string') {
                return result;
            }
        }
    }
};
